import { create } from "zustand";

export type SidebarState = {
	collapsed: boolean;
	setCollapsed: (val: boolean) => void;
	toggleCollapsed: () => void;
};

export const useSidebarStore = create<SidebarState>((set) => ({
	collapsed: false,
	setCollapsed: (val: boolean) => set({ collapsed: val }),
	toggleCollapsed: () => set((state) => ({ collapsed: !state.collapsed }))
}));
